<pr-form (onSubmit)="onSubmit()" [title]="title" [formGroup]="form">
  <pr-file
    (fileChange)="onLoadFiles($event)"
    [form]="true"
    [fileForm]="file"
  ></pr-file>
</pr-form>
